module.exports = __webpack_public_path__ + "static/media/robotArm.71f41de1.mp4";